import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _get from "lodash/get";
import _isEmpty from "lodash/isEmpty";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.fixed.js";
import React from 'react';
import classNames from 'classnames';
import { TableCell } from './TableCell';
import { wrapWithAlign } from './utils';
import styles from './Table.module.less';
export var BaseTable = /*#__PURE__*/React.memo(function (_ref) {
  var ariaLabel = _ref['aria-label'],
      ariaLabelledBy = _ref['aria-labelledby'],
      className = _ref.className,
      columns = _ref.columns,
      data = _ref.data,
      _ref$hasTableHeader = _ref.hasTableHeader,
      hasTableHeader = _ref$hasTableHeader === void 0 ? true : _ref$hasTableHeader,
      _ref$striped = _ref.striped,
      striped = _ref$striped === void 0 ? true : _ref$striped,
      fixedHeader = _ref.fixedHeader;

  if (_isEmpty(columns) || _isEmpty(data)) {
    return null;
  } // Tracks where we are in a colSpan


  var curColSpan = 0;
  return /*#__PURE__*/React.createElement("table", {
    className: classNames(styles.table, className),
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy // All components need to be keyboard usable, `tabIndex="0"`
    // is a rare acceptable exception
    // https://dequeuniversity.com/rules/axe/3.5/scrollable-region-focusable?application=axeAPI
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    ,
    tabIndex: 0
  }, hasTableHeader && /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    className: classNames(styles.stripedBackground, _defineProperty({}, styles.fixedHeaderRow, fixedHeader))
  }, columns.map(function (column, index) {
    var _classNames2, _column$align;

    curColSpan -= 1;
    if (curColSpan > 0) return undefined;
    if (column.colSpan) curColSpan = column.colSpan; // only the first column can be fixed, if `fixedHeader` is present it will override the value, and prevent horizontal scrolling

    var isFixedColumn = !fixedHeader && index === 0 && column.fixed;
    return /*#__PURE__*/React.createElement(TableCell, {
      element: "th",
      key: column.id,
      className: classNames(column.className, (_classNames2 = {}, _defineProperty(_classNames2, styles.fixedHeaderColumn, isFixedColumn), _defineProperty(_classNames2, styles.fixedHeaderRow, fixedHeader), _classNames2)),
      width: column.width,
      scope: "col",
      colSpan: column.colSpan
    }, wrapWithAlign((_column$align = column.align) !== null && _column$align !== void 0 ? _column$align : 'left', column.heading));
  }))), /*#__PURE__*/React.createElement("tbody", null, data.map(function (row, index) {
    curColSpan = 0;
    return /*#__PURE__*/React.createElement("tr", {
      key: row.key,
      className: classNames([styles.tr, _defineProperty({}, styles.stripedBackground, striped && index % 2 !== 0)])
    }, columns.map(function (column, columnIndex) {
      var _classNames3;

      var colSpan = _get(row, ['colSpans', column.id]);

      curColSpan -= 1;
      if (curColSpan > 0) return undefined;
      if (colSpan) curColSpan = colSpan; // only the first column can be fixed, if `fixedHeader` is present it will override the value, and prevent horizontal scrolling

      var isFixedColumn = !fixedHeader && columnIndex === 0 && column.fixed;
      return /*#__PURE__*/React.createElement(TableCell, {
        key: column.id,
        element: column.rowHeader ? 'th' : 'td',
        className: classNames(column.className, row.className, (_classNames3 = {}, _defineProperty(_classNames3, styles.fixedRow, isFixedColumn), _defineProperty(_classNames3, styles.stripedBackground, striped && index % 2 !== 0), _classNames3)),
        colSpan: colSpan
      }, wrapWithAlign(row.align || column.align, _get(row, column.id)));
    }));
  })));
});